import React from "react";
import "../App.css";
import flipper from "../images/hexagonFlipper.png";
import person from "../images/hexagonPerson.png";
import lock from "../images/hexagonLock.png";
import arrow from "../images/arrow_icon.png";

function scrollIntoView() {
    document.getElementById("thirdScreen").scrollIntoView();
}

const SecondScreen = () => {
    return (
        <div className="ss">
            <div className="ss-title">
                <h1>Waarom is het belangrijk om je scherm te vergrendelen?</h1>
            </div>
            <div className="ss-images">
                <div className="ss-1 ss-item">
                    <img
                        src={lock}
                        alt="hexagon met slotje"
                        className="hex-1"
                    />
                    <h2>Beveiliging</h2> <br />
                    <p>
                        Kwaadwillenden hebben toegang tot gevoelige informatie,
                        waardoor bijvoorbeeld cyberaanvallen kunnen ontstaan.
                        Ook kan malafide software geïnstalleerd worden.
                    </p>
                </div>
                <div className="ss-2 ss-item">
                    <img
                        src={person}
                        alt="hexagon met poppetje"
                        className="hex-2"
                    />
                    <h2>Privacy</h2> <br />
                    <p>
                        Derden kunnen persoonlijke of gevoelige gegevens inzien,
                        zoals e-mails of documenten. Dit kan tot een datalek of
                        privacyschendingen leiden voor jou en anderen.
                    </p>
                </div>
                <div className="ss-3 ss-item">
                    <img
                        src={flipper}
                        alt="hexagon met flipper"
                        className="hex-3"
                    />
                    <h2>Flipper Zero</h2> <br />
                    <p>
                        Hacking-tools als de Flipper Zero kunnen gebruikt worden
                        om snel en onopvallend kwade acties op jouw ontgrendelde
                        werkplek uit te voeren.
                    </p>{" "}
                    <br />
                    <p>Meer weten over security awareness?</p>
                    <div className="ss-button">
                        <button className="ss-button" onClick={scrollIntoView}>
                            <img
                                src={arrow}
                                alt="pijl naar beneden"
                                className="arrow2-img"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecondScreen;
